/* 棚 */
import React from 'react';
import { Collapse, Card } from 'react-bootstrap';
var Shelf = function (_a) {
    var label = _a.label, is_open = _a.is_open, handleClick = _a.handleClick, children = _a.children, _b = _a.is_click_disabled, is_click_disabled = _b === void 0 ? false : _b;
    return (React.createElement(Card, { className: "shelf mx-auto px-0 col-11 col-xs-10 col-lg-9" },
        React.createElement(Card.Header, { className: "shelf-header", onClick: is_click_disabled ? undefined : handleClick, "aria-expanded": is_open },
            label,
            !is_click_disabled && React.createElement("span", { className: "triangle" }, is_open ? '▼' : '▶')),
        React.createElement(Collapse, { className: "collapse-body", in: is_open },
            React.createElement("div", null,
                React.createElement(Card.Body, { className: "p-2" },
                    React.createElement("div", null, children))))));
};
export default Shelf;
